import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { fileUrl } from "@/lib/api";
import { Seo, SITE_URL } from "@/components/Seo";
import { Footer } from "@/components/Footer";
import { SkeletonCard } from "@/components/Loaders";
import { Article, CaretLeft } from "@phosphor-icons/react";

export default function Blog() {
  const navigate = useNavigate();
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);

  return (
    <>
      <Seo title="Blog & Guides — Farmhouses, Resorts & Halls in Hyderabad" path="/blog"
        description="Guides and tips for booking farmhouses, resorts, banquet halls and function halls in and around Hyderabad."
        jsonLd={{ "@context": "https://schema.org", "@type": "Blog", name: "Avinya Bookings Blog", url: `${SITE_URL}/blog` }} />
      <header className="border-b border-stone-200 bg-white/90 px-4 py-3 backdrop-blur">
        <div className="mx-auto flex max-w-4xl items-center gap-3">
          <button onClick={() => navigate("/")} className="text-stone-500 hover:text-stone-800"><CaretLeft size={20} /></button>
          <span className="font-heading text-xl font-extrabold text-primary">Avinya <span className="font-semibold text-stone-800">Blog</span></span>
        </div>
      </header>

      <div className="mx-auto max-w-4xl px-4 py-8">
        <h1 className="font-heading text-3xl font-bold text-stone-900 md:text-4xl">Guides & Inspiration</h1>
        <p className="mt-2 text-base text-stone-600">Tips to plan the perfect celebration around Hyderabad.</p>

        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {posts === null ? [1, 2, 3, 4].map((i) => <SkeletonCard key={i} />)
            : posts.length === 0 ? <p className="text-sm text-stone-400">No articles published yet. Check back soon!</p>
            : posts.map((p) => (
              <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group overflow-hidden rounded-2xl border border-stone-200 bg-white transition-shadow hover:shadow-md">
                {p.featured_image ? <img src={fileUrl(p.featured_image)} alt={p.title} className="h-44 w-full object-cover" />
                  : <div className="flex h-44 w-full items-center justify-center bg-accent/40"><Article size={30} className="text-primary/50" /></div>}
                <div className="p-4">
                  <span className="text-xs font-medium text-primary">{p.category}</span>
                  <h2 className="mt-1 font-heading text-lg font-semibold text-stone-900 group-hover:text-primary">{p.title}</h2>
                  <p className="mt-1 line-clamp-2 text-sm text-stone-500">{p.excerpt}</p>
                  <p className="mt-2 text-xs text-stone-400">{p.author}{p.published_at ? ` · ${new Date(p.published_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}` : ""}</p>
                </div>
              </Link>
            ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
